import { ClientConfigProductName } from '@frontend/vanilla/core';

export const WidgetComposableLoader = {
    id: 'widget-composable',
    loaderFn: () => import(/* webpackChunkName: "ms-widget-composable" */ './composable-widget.feature'),
    product: ClientConfigProductName.SPORTS,
};
